webpackJsonp([77],{

/***/ 1278:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);






var metas = {
  "category": {
    "en": "Form",
    "zh-CN": "表单"
  },
  "icon": "&#xe62a;",
  "extra": {
    "zh-CN": "```html\n  <group>\n    <cell title=\"title\" value=\"value\"></cell>\n  </group>\n```\n\n::: tip\nCell 组件只能在`Group`中使用\n:::\n"
  },
  "tags": {
    "en": ["cell", "form"],
    "zh-CN": ["表单", "列表"]
  },
  "props": {
    "title": {
      "type": "String",
      "default": "",
      "en": "label text on the left",
      "zh-CN": "左边标题文字"
    },
    "value": {
      "type": "String",
      "default": "",
      "en": "right text",
      "zh-CN": "右侧文字，复杂的样式布局请使用slot"
    },
    "inline-desc": {
      "type": "String",
      "default": "",
      "en": "the text below title",
      "zh-CN": "标题下面文字，一般为说明文字"
    },
    "link": {
      "type": "String, Object",
      "en": "redirect link. Can be http(s) protocol; can also be vue-router format",
      "zh-CN": "点击链接，可以为http(s)协议，也可以是 vue-router 支持的地址形式"
    },
    "is-link": {
      "type": "Boolean",
      "default": false,
      "en": "if this is a link; if true, there will be an arrow on the right",
      "zh-CN": "是否为链接，如果是，右侧将会出现指引点击的右箭头"
    },
    "primary": {
      "type": "String",
      "default": "title",
      "en": "main content area, can be in ['title', 'content']",
      "zh-CN": "可选值为 ['title', 'content']，对应的div会加上weui_cell_primary类名实现内容宽度自适应"
    },
    "is-loading": {
      "version": "v2.2.0",
      "type": "Boolean",
      "default": false,
      "en": "if show loading icon, good for asynchronous loading",
      "zh-CN": "是否显示加载图标，适用于异步加载数据的场景"
    },
    "value-align": {
      "version": "v2.2.0",
      "default": "left",
      "en": "value's text-align，one of left, right. prop:primary will be set to content if value-align value is right",
      "zh-CN": "文字值对齐方式，可选值为 left right。当设为 right 时，primary 值将会设为 content"
    },
    "border-intent": {
      "version": "v2.2.1-rc.1",
      "type": "Boolean",
      "default": true,
      "en": "if set border intent on the left side",
      "zh-CN": "是否显示边框与左边的间隙"
    },
    "arrow-direction": {
      "version": "v2.2.1-rc.1",
      "type": "String",
      "en": "arrow direction, one of up, down",
      "zh-CN": "右侧箭头方向，可选有 up down"
    },
    "disabled": {
      "version": "v2.2.2",
      "type": "Boolean",
      "en": "set disabled style for label and arrow (if is-link is true)",
      "zh-CN": "对 label 和箭头(如果使用 is-link )显示不可操作样式"
    },
    "align-items": {
      "version": "v2.6.4",
      "type": "String",
      "default": "center",
      "en": "align-items value",
      "zh-CN": "align-items 样式值"
    }
  },
  "slots": {
    "default": {
      "en": "right area, you can use default slot instead of prop:value so you can use complicated layout",
      "zh-CN": "右侧内容，相比于value的优点是可以用复杂的样式或者调用组件"
    },
    "value": {
      "en": "[deprecated] the same as default slot",
      "zh-CN": "[废弃] 同默认slot"
    },
    "icon": {
      "en": "icon area before title",
      "zh-CN": "标题左侧的图像位置"
    },
    "after-title": {
      "en": "after title",
      "zh-CN": "标题右侧位置"
    },
    "child": {
      "en": "the child element of the cell, you can add an element with absolute position",
      "zh-CN": "cell的直接子元素，因此可以添加一个相对于cell绝对定位的元素"
    },
    "inline-desc": {
      "version": "v2.2.1-rc.6",
      "en": "inline-desc slot, the same function as prop:inline-desc but can use html",
      "zh-CN": "inline-desc 内容，和 prop:inline-desc 功能一样，但是可以使用 html"
    },
    "title": {
      "version": "v2.3.3",
      "en": "title slot",
      "zh-CN": "title 插槽，方便自定义样式"
    }
  },
  "changes": {
    "v2.9.0": {
      "en": ["[fix] fix weui-loading style"],
      "zh-CN": ["[fix] 修复 weui-loading 样式"]
    },
    "v2.8.1": {
      "en": ["[fix] fix justify class #2545"],
      "zh-CN": ["[fix] 修复 justify 类名 #2545"]
    },
    "v2.7.0": {
      "en": ["[fix] fix ssr rendering issue"],
      "zh-CN": ["[fix] 修复 ssr 渲染问题"]
    },
    "v2.6.4": {
      "en": ["[feature] support prop:align-items"],
      "zh-CN": ["[feature] 支持属性 align-items"]
    },
    "v2.3.6": {
      "en": ["[feature] Support arrow less variables"],
      "zh-CN": ["[feature] 支持多个箭头样式变量"]
    },
    "v2.3.3": {
      "en": ["[feature] Support slot:title"],
      "zh-CN": ["[feature] 支持 slot:title"]
    },
    "v2.2.2": {
      "en": ["[feature] Support prop:disabled"],
      "zh-CN": ["[feature] 支持 prop:disabled 显示禁用样式"]
    },
    "v2.2.1-rc.6": {
      "en": ["[feature] Support slot:inline-desc"],
      "zh-CN": ["[feature] 支持 slot:inline-desc"]
    },
    "v2.2.1-rc.1": {
      "en": ["[feature] Support prop:border-intent", "[feature] Support prop:arrow-direction"],
      "zh-CN": ["[feature] 支持 prop:border-intent, 用以不显示边框与左边间隙", "[feature] 支持 prop:arrow-direction, 用以在折叠场景下动态更改方向"]
    },
    "v2.2.0": {
      "en": ["[feature] Support prop:is-loading"],
      "zh-CN": ["[feature] 支持 prop:is-loading 显示加载图标，适用于异步加载数据的场景"]
    },
    "v2.1.1-rc.13": {
      "en": ["[fix] Support Group label styles #1110"],
      "zh-CN": ["[fix] 修复 label 宽度不受控于 Group #1110"]
    },
    "v2.1.1-rc.3": {
      "en": ["[feature] Add font-size variable #990 @wg5945"],
      "zh-CN": ["[feature] 支持字体变量 #990 @wg5945"]
    },
    "v2.1.0-rc.47": {
      "zh-CN": ["[enhance] 修复内容多时的箭头位置 #715 @greedying "]
    }
  },
  "variables": [{
    "name": "cell-label-color",
    "value": "#000",
    "is_inherited": false,
    "inherited_name": "",
    "desc": {}
  }, {
    "name": "cell-font-size",
    "value": "17px",
    "is_inherited": false,
    "inherited_name": "",
    "desc": {}
  }, {
    "name": "cell-tips-font-size",
    "value": "14px",
    "is_inherited": false,
    "inherited_name": "",
    "desc": {}
  }, {
    "name": "cell-default-arrow-color",
    "value": "#C8C8CD",
    "is_inherited": false,
    "inherited_name": "",
    "desc": {}
  }, {
    "name": "cell-disabled-arrow-color",
    "value": "#e2e2e2",
    "is_inherited": false,
    "inherited_name": "",
    "desc": {}
  }, {
    "name": "cell-default-arrow-border-width",
    "value": "2px",
    "is_inherited": false,
    "inherited_name": "",
    "desc": {}
  }, {
    "name": "cell-default-arrow-width",
    "value": "6px",
    "is_inherited": false,
    "inherited_name": "",
    "desc": {}
  }, {
    "name": "cell-value-color",
    "value": "#999",
    "is_inherited": false,
    "inherited_name": "",
    "desc": {}
  }, {
    "name": "cell-placeholder-color",
    "value": "#999",
    "is_inherited": false,
    "inherited_name": "",
    "desc": {}
  }, {
    "name": "cell-body-label-color",
    "value": "#000",
    "is_inherited": false,
    "inherited_name": "",
    "desc": {}
  }]
};
var demos = [];

var componentList = [];
if (Array.isArray(metas.items)) {
  try {
    metas.items.forEach(function (item, index) {
      var meta = {
        name: item,
        meta: metas[item]
      };
      if (meta.meta.props === null) {
        delete meta.meta.props;
      }
      if (index === metas.items.length - 1) {
        if (meta.meta) {
          meta.meta.variables = metas.variables;
        }
      }
      componentList.push(meta);
    });
  } catch (e) {
    console.log(e);
  }
} else {
  componentList.push({
    meta: metas
  });
}
var gitMetas = __webpack_require__(2492);
var demoCode = decodeURIComponent("%3Cpre%20class%3D%22hljs%22%3E%3Ccode%3E%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Etemplate%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ediv%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Egroup%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ecell%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Atitle%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22%24t('My%20Account')%22%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Avalue%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22%24t('Protected')%22%3C%2Fspan%3E%20%40%3Cspan%20class%3D%22hljs-attr%22%3Eclick.native%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22onClick%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ecell%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ecell%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Atitle%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22%24t('Money')%22%3C%2Fspan%3E%20%40%3Cspan%20class%3D%22hljs-attr%22%3Eclick.native%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22onClick%22%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Ais-loading%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22!money%22%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Avalue%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22money%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ecell%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ecell%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Atitle%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22%24t('Withdraw')%22%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Edisabled%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Eis-link%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ecell%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Egroup%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%0A%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Egroup%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Atitle%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22%24t('Use%20is-link%20to%20show%20arrow')%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ecell%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Eis-link%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Espan%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Eslot%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22title%22%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Estyle%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22color%3Agreen%3B%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Espan%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Estyle%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22vertical-align%3Amiddle%3B%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%7B%7B%20%24t('Messages')%20%7D%7D%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Espan%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ebadge%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Etext%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%221%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ebadge%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Espan%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ecell%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ecell%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Atitle%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22%24t('Notifications')%22%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Eis-link%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ecell%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ecell%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Atitle%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22%24t('Privacy')%22%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Eis-link%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ecell%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ecell%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Atitle%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22%24t('General')%22%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Eis-link%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Eimg%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Eslot%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22icon%22%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Ewidth%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%2220%22%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Estyle%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22display%3Ablock%3Bmargin-right%3A5px%3B%22%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Esrc%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22data%3Aimage%2Fpng%3Bbase64%2CiVBORw0KGgoAAAANSUhEUgAAAC4AAAAuCAMAAABgZ9sFAAAAVFBMVEXx8fHMzMzr6%2Bvn5%2Bfv7%2B%2Ft7e3d3d2%2Bvr7W1tbHx8eysrKdnZ3p6enk5OTR0dG7u7u3t7ejo6PY2Njh4eHf39%2FT09PExMSvr6%2BgoKCqqqqnp6e4uLgcLY%2FOAAAAnklEQVRIx%2B3RSRLDIAxE0QYhAbGZPNu5%2Fz0zrXHiqiz5W72FqhqtVuuXAl3iOV7iPV%2FiSsAqZa9BS7YOmMXnNNX4TWGxRMn3R6SxRNgy0bzXOW8EBO8SAClsPdB3psqlvG%2BLw7ONXg%2FpTld52BjgSSkA3PV2OOemjIDcZQWgVvONw60q7sIpR38EnHPSMDQ4MjDjLPozhAkGrVbr%2Fz0ANjAF4AcbXmYAAAAASUVORK5CYII%3D%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ecell%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Egroup%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%0A%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Egroup%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Elabel-width%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%225em%22%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Etitle%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22Align-items%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ecell%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Eprimary%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22content%22%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Etitle%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22default%22%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Evalue%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22long%20long%20long%20longlong%20longlong%20longlong%20longlong%20longlong%20longlong%20longlong%20longlong%20long%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ecell%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ecell%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Etitle%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22flex-start%22%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Ealign-items%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22flex-start%22%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Evalue%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22long%20long%20long%20longlong%20longlong%20longlong%20longlong%20longlong%20longlong%20longlong%20longlong%20long%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ecell%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Egroup%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%0A%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Egroup%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Atitle%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22%24t('Collapse')%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ecell%3C%2Fspan%3E%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Atitle%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22%24t('Title%20001')%22%3C%2Fspan%3E%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-attr%22%3Eis-link%3C%2Fspan%3E%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Aborder-intent%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22false%22%3C%2Fspan%3E%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Aarrow-direction%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22showContent001%20%3F%20'up'%20%3A%20'down'%22%3C%2Fspan%3E%0A%20%20%20%20%20%20%40%3Cspan%20class%3D%22hljs-attr%22%3Eclick.native%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22showContent001%20%3D%20!showContent001%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ecell%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Etemplate%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Ev-if%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22showContent001%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ecell-box%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Aborder-intent%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22false%22%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Eclass%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22sub-item%22%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Eis-link%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3Econtent%20001%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ecell-box%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ecell-box%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Eclass%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22sub-item%22%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Eis-link%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3Econtent%20001%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ecell-box%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ecell-box%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Eclass%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22sub-item%22%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Eis-link%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3Econtent%20001%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ecell-box%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Etemplate%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ecell%3C%2Fspan%3E%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Atitle%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22%24t('Title%20002')%22%3C%2Fspan%3E%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-attr%22%3Eis-link%3C%2Fspan%3E%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Aborder-intent%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22false%22%3C%2Fspan%3E%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Aarrow-direction%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22showContent002%20%3F%20'up'%20%3A%20'down'%22%3C%2Fspan%3E%0A%20%20%20%20%20%20%40%3Cspan%20class%3D%22hljs-attr%22%3Eclick.native%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22showContent002%20%3D%20!showContent002%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ecell%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Etemplate%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Ev-if%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22showContent002%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ecell-form-preview%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Aborder-intent%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22false%22%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Alist%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22list%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ecell-form-preview%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Etemplate%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ecell%3C%2Fspan%3E%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Atitle%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22%24t('Title%20003')%22%3C%2Fspan%3E%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-attr%22%3Eis-link%3C%2Fspan%3E%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Aborder-intent%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22false%22%3C%2Fspan%3E%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Aarrow-direction%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22showContent003%20%3F%20'up'%20%3A%20'down'%22%3C%2Fspan%3E%0A%20%20%20%20%20%20%40%3Cspan%20class%3D%22hljs-attr%22%3Eclick.native%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22showContent003%20%3D%20!showContent003%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ecell%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Etemplate%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Ev-if%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22showContent003%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ecell-box%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Aborder-intent%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22false%22%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Eclass%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22sub-item%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3EI'm%20content%20003%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ecell-box%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Etemplate%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ecell%3C%2Fspan%3E%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Atitle%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22%24t('Animated')%22%3C%2Fspan%3E%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-attr%22%3Eis-link%3C%2Fspan%3E%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Aborder-intent%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22false%22%3C%2Fspan%3E%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Aarrow-direction%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22showContent004%20%3F%20'up'%20%3A%20'down'%22%3C%2Fspan%3E%0A%20%20%20%20%20%20%40%3Cspan%20class%3D%22hljs-attr%22%3Eclick.native%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22showContent004%20%3D%20!showContent004%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ecell%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ep%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Eclass%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22slide%22%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Aclass%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22showContent004%3F'animate'%3A''%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3Eblablabla...%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ebr%3C%2Fspan%3E%2F%26gt%3B%3C%2Fspan%3Eblablabla...%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ebr%3C%2Fspan%3E%2F%26gt%3B%3C%2Fspan%3Eblablabla...%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ebr%3C%2Fspan%3E%2F%26gt%3B%3C%2Fspan%3Eblablabla...%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ep%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%0A%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Egroup%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%0A%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Egroup%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ecell%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Atitle%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22%24t('Notifications')%22%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Avalue%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22%24t('Enabled')%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ecell%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Egroup%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%0A%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Egroup%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Atitle%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22%24t('Use%20slot%20for%20complicated%20content')%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ecell%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Atitle%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22%24t('Slot%20content')%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ediv%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Espan%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Estyle%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22color%3A%20green%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%7B%7B%24t('Hi%2C%20I%5C'm%20Vux.')%7D%7D%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Espan%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ediv%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ecell%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Egroup%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%0A%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Egroup%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Atitle%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22%24t('is-link%20is%20set%20to%20true%20automatically%20when%20link%20exists')%22%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ecell%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Atitle%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22%24t('Go%20to%20Radio%20Demo')%22%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Elink%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22%2Fcomponent%2Fradio%22%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Einline-desc%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E'link%3D%22%2Fcomponent%2Fradio%22'%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ecell%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ecell%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Atitle%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22%24t('Go%20to%20Demo')%22%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Alink%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22%7Bpath%3A'%2Fdemo'%7D%22%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Einline-desc%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E'%3Alink%3D%7Bpath%3A%22%2Fdemo%22%7D'%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ecell%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ecell%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3E%3Atitle%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22%24t('Http%20link')%22%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Elink%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E%22https%3A%2F%2Fvux.li%22%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Einline-desc%3C%2Fspan%3E%3D%3Cspan%20class%3D%22hljs-string%22%3E'link%3D%22https%3A%2F%2Fvux.li%22'%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ecell%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Egroup%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%20%20%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ediv%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Etemplate%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%0A%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Ei18n%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0AMy%20Account%3A%0A%20%20zh-CN%3A%20%E6%88%91%E7%9A%84%E8%B4%A6%E5%8F%B7%0AProtected%3A%0A%20%20zh-CN%3A%20%E4%BF%9D%E6%8A%A4%E4%B8%AD%0AUse%20is-link%20to%20show%20arrow%3A%0A%20%20zh-CN%3A%20%E4%BD%BF%E7%94%A8%20is-link%20%E6%98%BE%E7%A4%BA%E5%8F%B3%E8%BE%B9%E7%AE%AD%E5%A4%B4%0ANotifications%3A%0A%20%20zh-CN%3A%20%E9%80%9A%E7%9F%A5%0AEnabled%3A%0A%20%20zh-CN%3A%20%E5%B7%B2%E5%BC%80%E5%90%AF%0APrivacy%3A%0A%20%20zh-CN%3A%20%E9%9A%90%E7%A7%81%0AGeneral%3A%0A%20%20zh-CN%3A%20%E9%80%9A%E7%94%A8%0AUse%20slot%20for%20complicated%20content%3A%0A%20%20zh-CN%3A%20%E4%BD%BF%E7%94%A8slot%E6%98%BE%E7%A4%BA%E5%A4%8D%E6%9D%82%E5%86%85%E5%AE%B9%0ASlot%20content%3A%0A%20%20zh-CN%3A%20slot%20%E5%86%85%E5%AE%B9%0AHi%2C%20I'm%20Vux.%3A%0A%20%20zh-CN%3A%20%E4%BD%A0%E5%A5%BD%E5%93%87%EF%BC%8C%E6%84%9F%E8%B0%A2%E5%85%B3%E6%B3%A8%20Vux%0Ais-link%20is%20set%20to%20true%20automatically%20when%20link%20exists%3A%0A%20%20zh-CN%3A%20%E5%BD%93%E8%AE%BE%E6%9C%89%20link%20%E5%B1%9E%E6%80%A7%E6%97%B6%EF%BC%8C%E4%BC%9A%E8%87%AA%E5%8A%A8%E4%BA%A7%E7%94%9F%E7%AE%AD%E5%A4%B4%E6%95%88%E6%9E%9C%EF%BC%8C%E6%97%A0%E9%9C%80%E5%86%8D%E8%AE%BE%E7%BD%AE%20is-link%0AGo%20to%20Radio%20Demo%3A%0A%20%20zh-CN%3A%20%E5%89%8D%E5%BE%80Radio%E9%A1%B5%E9%9D%A2%0AGo%20to%20Demo%3A%0A%20%20zh-CN%3A%20%E5%89%8D%E5%BE%80Demo%E9%A1%B5%E9%9D%A2%0AHttp%20link%3A%0A%20%20zh-CN%3A%20%E7%AB%99%E5%A4%96%E9%93%BE%E6%8E%A5%0AMoney%3A%0A%20%20zh-CN%3A%20%E4%BD%99%E9%A2%9D%0ACollapse%3A%0A%20%20zh-CN%3A%20%E6%8A%98%E5%8F%A0%0ATitle%20001%3A%0A%20%20zh-CN%3A%20%E6%A0%87%E9%A2%98%E4%B8%80%0ATitle%20002%3A%0A%20%20zh-CN%3A%20%E6%A0%87%E9%A2%98%E4%BA%8C%0ATitle%20003%3A%0A%20%20zh-CN%3A%20%E6%A0%87%E9%A2%98%E4%B8%89%0AAnimated%3A%0A%20%20zh-CN%3A%20%E5%8A%A8%E7%94%BB%E6%95%88%E6%9E%9C%0AWithdraw%3A%0A%20%20zh-CN%3A%20%E6%8F%90%E7%8E%B0%0AMessages%3A%0A%20%20zh-CN%3A%20%E6%B6%88%E6%81%AF%0A%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Ei18n%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%0A%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Escript%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%3Cspan%20class%3D%22javascript%22%3E%0A%3Cspan%20class%3D%22hljs-keyword%22%3Eimport%3C%2Fspan%3E%20%7B%20Cell%2C%20CellBox%2C%20CellFormPreview%2C%20Group%2C%20Badge%20%7D%20%3Cspan%20class%3D%22hljs-keyword%22%3Efrom%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-string%22%3E'vux'%3C%2Fspan%3E%0A%0A%3Cspan%20class%3D%22hljs-keyword%22%3Eexport%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-keyword%22%3Edefault%3C%2Fspan%3E%20%7B%0A%20%20mounted%20()%20%7B%0A%20%20%20%20setTimeout(%3Cspan%20class%3D%22hljs-function%22%3E%3Cspan%20class%3D%22hljs-params%22%3E()%3C%2Fspan%3E%20%3D%26gt%3B%3C%2Fspan%3E%20%7B%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-keyword%22%3Ethis%3C%2Fspan%3E.money%20%3D%20%3Cspan%20class%3D%22hljs-number%22%3E-1024%3C%2Fspan%3E%0A%20%20%20%20%7D%2C%20%3Cspan%20class%3D%22hljs-number%22%3E2000%3C%2Fspan%3E)%0A%20%20%7D%2C%0A%20%20%3Cspan%20class%3D%22hljs-attr%22%3Ecomponents%3C%2Fspan%3E%3A%20%7B%0A%20%20%20%20Group%2C%0A%20%20%20%20Cell%2C%0A%20%20%20%20CellFormPreview%2C%0A%20%20%20%20CellBox%2C%0A%20%20%20%20Badge%0A%20%20%7D%2C%0A%20%20%3Cspan%20class%3D%22hljs-attr%22%3Emethods%3C%2Fspan%3E%3A%20%7B%0A%20%20%20%20onClick%20()%20%7B%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-built_in%22%3Econsole%3C%2Fspan%3E.log(%3Cspan%20class%3D%22hljs-string%22%3E'on%20click'%3C%2Fspan%3E)%0A%20%20%20%20%7D%0A%20%20%7D%2C%0A%20%20data%20()%20%7B%0A%20%20%20%20%3Cspan%20class%3D%22hljs-keyword%22%3Ereturn%3C%2Fspan%3E%20%7B%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-attr%22%3Elist%3C%2Fspan%3E%3A%20%5B%7B%0A%20%20%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-attr%22%3Elabel%3C%2Fspan%3E%3A%20%3Cspan%20class%3D%22hljs-string%22%3E'Apple'%3C%2Fspan%3E%2C%0A%20%20%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-attr%22%3Evalue%3C%2Fspan%3E%3A%20%3Cspan%20class%3D%22hljs-string%22%3E'3.29'%3C%2Fspan%3E%0A%20%20%20%20%20%20%7D%2C%20%7B%0A%20%20%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-attr%22%3Elabel%3C%2Fspan%3E%3A%20%3Cspan%20class%3D%22hljs-string%22%3E'Banana'%3C%2Fspan%3E%2C%0A%20%20%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-attr%22%3Evalue%3C%2Fspan%3E%3A%20%3Cspan%20class%3D%22hljs-string%22%3E'1.04'%3C%2Fspan%3E%0A%20%20%20%20%20%20%7D%2C%20%7B%0A%20%20%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-attr%22%3Elabel%3C%2Fspan%3E%3A%20%3Cspan%20class%3D%22hljs-string%22%3E'Fish'%3C%2Fspan%3E%2C%0A%20%20%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-attr%22%3Evalue%3C%2Fspan%3E%3A%20%3Cspan%20class%3D%22hljs-string%22%3E'8.00'%3C%2Fspan%3E%0A%20%20%20%20%20%20%7D%5D%2C%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-attr%22%3Emoney%3C%2Fspan%3E%3A%20%3Cspan%20class%3D%22hljs-literal%22%3Enull%3C%2Fspan%3E%2C%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-attr%22%3EshowContent001%3C%2Fspan%3E%3A%20%3Cspan%20class%3D%22hljs-literal%22%3Efalse%3C%2Fspan%3E%2C%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-attr%22%3EshowContent002%3C%2Fspan%3E%3A%20%3Cspan%20class%3D%22hljs-literal%22%3Efalse%3C%2Fspan%3E%2C%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-attr%22%3EshowContent003%3C%2Fspan%3E%3A%20%3Cspan%20class%3D%22hljs-literal%22%3Efalse%3C%2Fspan%3E%2C%0A%20%20%20%20%20%20%3Cspan%20class%3D%22hljs-attr%22%3EshowContent004%3C%2Fspan%3E%3A%20%3Cspan%20class%3D%22hljs-literal%22%3Efalse%3C%2Fspan%3E%0A%20%20%20%20%7D%0A%20%20%7D%0A%7D%0A%3C%2Fspan%3E%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Escript%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%0A%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%3Cspan%20class%3D%22hljs-name%22%3Estyle%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-attr%22%3Escoped%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%3Cspan%20class%3D%22css%22%3E%0A%3Cspan%20class%3D%22hljs-selector-class%22%3E.sub-item%3C%2Fspan%3E%20%7B%0A%20%20%3Cspan%20class%3D%22hljs-attribute%22%3Ecolor%3C%2Fspan%3E%3A%20%3Cspan%20class%3D%22hljs-number%22%3E%23888%3C%2Fspan%3E%3B%0A%7D%0A%3Cspan%20class%3D%22hljs-selector-class%22%3E.slide%3C%2Fspan%3E%20%7B%0A%20%20%3Cspan%20class%3D%22hljs-attribute%22%3Epadding%3C%2Fspan%3E%3A%20%3Cspan%20class%3D%22hljs-number%22%3E0%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-number%22%3E20px%3C%2Fspan%3E%3B%0A%20%20%3Cspan%20class%3D%22hljs-attribute%22%3Eoverflow%3C%2Fspan%3E%3A%20hidden%3B%0A%20%20%3Cspan%20class%3D%22hljs-attribute%22%3Emax-height%3C%2Fspan%3E%3A%20%3Cspan%20class%3D%22hljs-number%22%3E0%3C%2Fspan%3E%3B%0A%20%20%3Cspan%20class%3D%22hljs-attribute%22%3Etransition%3C%2Fspan%3E%3A%20max-height%20.%3Cspan%20class%3D%22hljs-number%22%3E5s%3C%2Fspan%3E%20%3Cspan%20class%3D%22hljs-built_in%22%3Ecubic-bezier%3C%2Fspan%3E(0%2C%201%2C%200%2C%201)%20-.%3Cspan%20class%3D%22hljs-number%22%3E1s%3C%2Fspan%3E%3B%0A%7D%0A%3Cspan%20class%3D%22hljs-selector-class%22%3E.animate%3C%2Fspan%3E%20%7B%0A%20%20%3Cspan%20class%3D%22hljs-attribute%22%3Emax-height%3C%2Fspan%3E%3A%20%3Cspan%20class%3D%22hljs-number%22%3E9999px%3C%2Fspan%3E%3B%0A%20%20%3Cspan%20class%3D%22hljs-attribute%22%3Etransition-timing-function%3C%2Fspan%3E%3A%20%3Cspan%20class%3D%22hljs-built_in%22%3Ecubic-bezier%3C%2Fspan%3E(0.5%2C%200%2C%201%2C%200)%3B%0A%20%20%3Cspan%20class%3D%22hljs-attribute%22%3Etransition-delay%3C%2Fspan%3E%3A%20%3Cspan%20class%3D%22hljs-number%22%3E0s%3C%2Fspan%3E%3B%0A%7D%0A%3C%2Fspan%3E%3Cspan%20class%3D%22hljs-tag%22%3E%26lt%3B%2F%3Cspan%20class%3D%22hljs-name%22%3Estyle%3C%2Fspan%3E%26gt%3B%3C%2Fspan%3E%0A%3C%2Fcode%3E%3C%2Fpre%3E");

var domainMap = {
  'development': 'http://localhost:8080/',
  'production': 'https://vux-demos.bobjoy.eu.org/'
};

/* harmony default export */ __webpack_exports__["default"] = ({
  head: {
    title: 'Cell 组件使用教程 | VUX - 基于 WeUI 和 Vue 的移动端组件库',
    meta: [{
      name: 'description',
      content: 'Vue component cell for the VUX framework.'
    }, {
      name: 'keywords',
      content: 'cell, vue-cell, vux-cell, vue mobile components'
    }, {
      property: 'og:title',
      content: 'Cell 组件使用教程 | VUX - 基于 WeUI 和 Vue 的移动端组件库'
    }, {
      property: 'og:description',
      content: 'Vue component cell for the VUX framework.'
    }],

    link: [{ "rel": "alternate", "hreflang": "en", "href": "/en/components/cell.html" }],
    script: [{
      innerHTML: '{"@context":"http://schema.org/","@type":"SoftwareApplication","name":"Vue Component cell","screenshot":"","description":"Vue.js component for VUX","url":"/zh-CN/components/cell.html","applicationCategory":"组件","author":{"@type":"Organization","name":"VUX","url":"https://vux.li"},"downloadUrl":"https://vux.li","softwareVersion":"2.11.1","aggregateRating":{"@type":"AggregateRating","ratingValue":5,"reviewCount":1},"operatingSystem":"iOS >= 7, Android >= 4.1","offers":{"@type":"Offer","price":0,"priceCurrency":"CNY","availability":"http://schema.org/InStock"}}',
      type: 'application/ld+json'
    }],
    __dangerouslyDisableSanitizers: ['script']
  },
  filters: {
    parseCode: function parseCode(str) {
      return str.replace(/`(.*?)`/g, '<code>$1</code>');
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var rs;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('https://api.github.com/search/issues?q=repo:airyland/vux%20label:component/' + _this.componentName);

            case 2:
              rs = _context.sent;

              _this.issues = rs.data.items;
              _this.hasReady = true;

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  watch: {
    sourceCodeDialogVisibility: function sourceCodeDialogVisibility(val) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var mask;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!val) {
                  _context2.next = 5;
                  break;
                }

                _context2.next = 3;
                return _this2.$nextTick();

              case 3:
                mask = document.querySelector('.v-modal');

                mask && mask.addEventListener('click', function () {
                  _this2.sourceCodeDialogVisibility = false;
                });

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  },
  methods: {
    onCopyError: function onCopyError() {
      this.$message({
        type: 'error',
        message: '复制失败'
      });
    },
    onCopy: function onCopy() {
      this.$message({
        type: 'success',
        message: '复制成功'
      });
    },
    showSourceCode: function showSourceCode() {
      this.sourceCodeDialogVisibility = true;
    },
    getTypeHTML: function getTypeHTML(type) {
      type = type || 'String';
      if (/,/.test(type)) {
        var list = type.split(',').map(function (one) {
          return one.replace(/^s+|s+$/g, '');
        }).map(function (one) {
          var type = one ? one.toLowerCase() : 'string';
          return '<span class="type">' + type + '</span>';
        });
        return list.join('<br>');
      } else {
        type = type ? type.toLowerCase() : 'string';
        return '<span class="type">' + type + '</span>';
      }
    }
  },
  computed: {
    lang: function lang() {
      if (this.$route.path.indexOf('/en/') !== -1) {
        return 'en';
      }
      if (this.$route.path.indexOf('/zh-CN/') !== -1) {
        return 'zh-CN';
      }
      return 'en';
    }
  },
  data: function data() {
    return {
      demos: demos,
      isBeta: false,
      hasReady: false,
      issues: [],
      componentName: 'cell',
      demoCode: demoCode,
      sourceCodeDialogVisibility: false,
      showQr: false,
      metas: metas,
      gitMetas: gitMetas,
      componentList: componentList,
      localImportCode: "import { Cell } from 'vux'\n\nexport default {\n  components: {\n    Cell\n  }\n}",
      globalImportCode: "// \u5728\u5165\u53E3\u6587\u4EF6\u5168\u5C40\u5F15\u5165\n\nimport Vue from 'vue'\nimport { Cell } from 'vux'\n\nVue.component('cell', Cell)\n",
      needImport: true,
      toc: [],
      domain: domainMap["production"]
    };
  }
});

/***/ }),

/***/ 1497:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(306)(false);
// imports


// module
exports.push([module.i, ".component-box{position:relative}.component-demo{position:absolute;right:5px;top:15px}.prop-color{display:inline-block;width:10px;height:10px;border:1px solid #aaa}.changelog-version{width:110px;display:inline-block}.component-extra-links{position:relative;font-size:12px}.component-extra-links a{padding-right:10px;color:#999}", ""]);

// exports


/***/ }),

/***/ 1663:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1497);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(307)("29e8d0d8", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"autoprefixer\":false,\"sourceMap\":false,\"minimize\":true}!../../node_modules/ream/node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-bea84b60\",\"scoped\":false,\"hasInlineConfig\":true}!../../node_modules/ream/node_modules/vue-loader/lib/selector.js?type=styles&index=0!./cell.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"autoprefixer\":false,\"sourceMap\":false,\"minimize\":true}!../../node_modules/ream/node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-bea84b60\",\"scoped\":false,\"hasInlineConfig\":true}!../../node_modules/ream/node_modules/vue-loader/lib/selector.js?type=styles&index=0!./cell.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2433:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-box",
    class: _vm.demos.length ? 'components-with-toc' : ''
  }, [_c('div', {
    class: _vm.demos.length ? 'component-header-v2' : 'component-header-v1'
  }, [_c('a', {
    staticClass: "anchor",
    attrs: {
      "id": "intro"
    }
  }, [_vm._v("Cell")]), _c('div', {
    staticClass: "title-box"
  }, [(_vm.isBeta) ? _c('el-badge', {
    attrs: {
      "value": "Beta"
    }
  }, [_c('h1', {
    staticClass: "vux-component-name"
  }, [_vm._v("Cell")])]) : _c('h1', {
    staticClass: "vux-component-name"
  }, [_vm._v("Cell")]), _c('p', {
    staticClass: "component-extra-links"
  }, [_c('a', {
    attrs: {
      "href": "https://vux-demos.bobjoy.eu.org/#/component/cell",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")]), (!_vm.demos.length) ? _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Cell.vue",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showSourceCode($event)
      }
    }
  }, [_vm._v("demo 源码")]) : _vm._e(), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/cell/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("编辑文档")]), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/cell/",
      "target": "_blank"
    }
  }, [_vm._v("组件源码")]), (_vm.hasReady) ? _c('el-popover', {
    attrs: {
      "trigger": "hover"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "center"
    }
  }, [_c('img', {
    staticClass: "qr",
    attrs: {
      "width": "100",
      "src": "https://qr.vux.li/api.php?text=https%3A%2F%2Fvux-demos.bobjoy.eu.org%2F%23%2Fcomponent%2Fcell"
    }
  })]), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    slot: "reference"
  }, [_vm._v("\n              二维码\n              ")])]) : _vm._e()], 1), _c('div', {
    staticClass: "component-description"
  }, [(false) ? void 0 : _vm._e()], 2)], 1), (!_vm.demos.length) ? _c('div', {
    staticClass: "component-demo",
    staticStyle: {
      "width": "377px",
      "height": "600px",
      "display": "inline-block",
      "border": "1px solid #ececec",
      "border-radius": "5px",
      "overflow": "hidden",
      "z-index": "2500"
    }
  }, [_c('iframe', {
    attrs: {
      "src": "https://vux-demos.bobjoy.eu.org?locale=zh-CN&transition=none/#/component/cell",
      "width": "375",
      "height": "600",
      "border": "0",
      "frameborder": "0"
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "toc"
  }, _vm._l((_vm.toc), function(t) {
    return _c('ul', [_c('li', [_c('a', {
      attrs: {
        "href": '#' + (t.anchor || t.title)
      }
    }, [_vm._v(_vm._s(t.title))]), _vm._l((t.list), function(_t) {
      return (t.list) ? _c('ul', [_c('li', [_c('a', {
        attrs: {
          "href": '#' + _t.anchor
        }
      }, [_vm._v(_vm._s(_t.title.slice(0, 12)))])])]) : _vm._e()
    })], 2)])
  })), (_vm.needImport) ? [_c('a', {
    staticClass: "anchor",
    attrs: {
      "id": "install"
    }
  }, [_vm._v("Install")]), _c('h2', [_vm._v("安装")]), _c('el-tabs', [_c('el-tab-pane', {
    attrs: {
      "label": "局部注册"
    }
  }, [_c('div', {
    staticClass: "import-code-box"
  }, [_c('el-tooltip', {
    attrs: {
      "content": "点击复制",
      "placement": "top"
    }
  }, [_c('span', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.localImportCode),
      expression: "localImportCode",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopy),
      expression: "onCopy",
      arg: "success"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:error",
      value: (_vm.onCopyError),
      expression: "onCopyError",
      arg: "error"
    }]
  }, [_c('el-icon', {
    staticClass: "el-icon-document"
  })], 1)]), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Cell } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("export")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("default")]), _vm._v(" {\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("components")]), _vm._v(": {\n    Cell\n  }\n}")])])], 1)]), _c('el-tab-pane', {
    attrs: {
      "label": "全局注册"
    }
  }, [_c('div', {
    staticClass: "import-code-box"
  }, [_c('el-tooltip', {
    attrs: {
      "content": "点击复制",
      "placement": "top"
    }
  }, [_c('span', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.globalImportCode),
      expression: "globalImportCode",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopy),
      expression: "onCopy",
      arg: "success"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:error",
      value: (_vm.onCopyError),
      expression: "onCopyError",
      arg: "error"
    }]
  }, [_c('el-icon', {
    staticClass: "el-icon-document"
  })], 1)]), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// 在入口文件全局引入")]), _vm._v("\n\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" Vue "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vue'")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Cell } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n\nVue.component("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'cell'")]), _vm._v(", Cell)\n")])])], 1)])], 1)] : [_c('div', {
    staticClass: "tip"
  }, [_c('p', [_vm._v("该组件可以直接使用，不需要引入。")])])], (_vm.metas.tip) ? _c('div', {
    staticClass: "tip",
    staticStyle: {
      "width": "600px"
    }
  }) : _vm._e(), (_vm.metas.example) ? _c('h2', [_vm._v("使用例子")]) : _vm._e(), (_vm.metas.example) ? _c('div', {
    staticStyle: {
      "width": "600px"
    }
  }) : _vm._e()], 2), (_vm.metas.extra && _vm.metas.extra['zh-CN']) ? _c('div', [_vm._m(0), _vm._m(1)]) : _vm._e(), (_vm.metas.extra && !_vm.metas.extra['zh-CN']) ? _c('div') : _vm._e(), (_vm.demos.length) ? _c('a', {
    staticClass: "anchor",
    attrs: {
      "id": "examples"
    }
  }, [_vm._v("Examples")]) : _vm._e(), _c('br'), _vm._l((_vm.demos), function(demo) {
    return (_vm.demos.length) ? [_c('a', {
      staticClass: "anchor",
      attrs: {
        "id": 'examples:' + demo.title
      }
    }, [_vm._v(_vm._s(demo.title))]), _c('br'), _c('div', {
      staticClass: "demo-header"
    }, [_c('span', {
      staticClass: "demo-title"
    }, [_vm._v(_vm._s(demo.title))])]), _c('div', {
      staticClass: "demos",
      style: ({
        height: demo.height
      })
    }, [_c('div', {
      staticClass: "demo-iframe-box"
    }, [_c('lazy-component', [_c('iframe', {
      staticStyle: {
        "margin": "0 auto"
      },
      attrs: {
        "src": _vm.domain + '?no-background-color=' + demo.noBackgroundColor + '&locale=zh-CN&transition=none&hide-nav=true&hide-tab-bar=true#/components/' + demo.file,
        "width": "375",
        "height": "600",
        "border": "0",
        "frameborder": "0"
      }
    })], 1)], 1), _c('div', {
      staticClass: "demo-code-box",
      style: ({
        overflow: demo.height === demo.oriHeight ? 'hidden' : 'scroll'
      })
    }, [_c('div', {
      attrs: {
        "contenteditable": ""
      },
      domProps: {
        "innerHTML": _vm._s(demo.code)
      }
    }), (demo.height === demo.oriHeight) ? _c('div', {
      staticClass: "demo-code-masker",
      on: {
        "click": function($event) {
          demo.height = 'auto'
        }
      }
    }, [_c('div', [_c('img', {
      staticClass: "demo-qr",
      attrs: {
        "width": "100",
        "src": 'https://qr.vux.li/api.php?text=' + encodeURIComponent(_vm.domain + '?locale=zh-CN#/components/' + demo.file)
      }
    }), _c('br'), _c('span', [_c('el-icon', {
      staticClass: "el-icon-arrow-left"
    }), _c('el-icon', {
      staticClass: "el-icon-arrow-right"
    }), _vm._v("\n                    Show code\n                  "), _c('br')], 1)])]) : _vm._e(), (demo.height === 'auto') ? _c('span', {
      staticClass: "hide-code",
      on: {
        "click": function($event) {
          demo.height = demo.oriHeight
        }
      }
    }, [_c('el-icon', {
      staticClass: "el-icon-close"
    })], 1) : _vm._e()])])] : _vm._e()
  }), _vm._l((_vm.componentList), function(component) {
    return [_c('div', [(_vm.componentList.length > 1) ? _c('a', {
      staticClass: "anchor",
      attrs: {
        "id": 'components:' + component.name
      }
    }, [_vm._v(_vm._s(component.name))]) : _c('a', {
      staticClass: "anchor",
      attrs: {
        "id": "api"
      }
    }, [_vm._v("API")]), _c('br'), _c('h2', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.componentList.length > 1),
        expression: "componentList.length > 1"
      }],
      staticClass: "vux-component-name-sub-item"
    }, [_vm._v(_vm._s(component.name))]), (component.meta.items && component.meta.description) ? [_c('div', {
      domProps: {
        "innerHTML": _vm._s(component.meta.description)
      }
    })] : _vm._e(), (component.meta.props) ? [_c('h2', [_vm._v("属性")]), _c('table', [_vm._m(2, true), _c('tbody', _vm._l((component.meta.props), function(prop, i) {
      return _c('tr', [_c('td', {
        staticClass: "prop-name"
      }, [_c('el-tooltip', {
        attrs: {
          "content": "点击复制",
          "placement": "left",
          "hide-after": 0,
          "open-delay": 50
        }
      }, [_c('span', {
        directives: [{
          name: "clipboard",
          rawName: "v-clipboard:copy",
          value: (i),
          expression: "i",
          arg: "copy"
        }, {
          name: "clipboard",
          rawName: "v-clipboard:success",
          value: (_vm.onCopy),
          expression: "onCopy",
          arg: "success"
        }]
      }, [_vm._v(_vm._s(i))])])], 1), _c('td', {
        domProps: {
          "innerHTML": _vm._s(_vm.getTypeHTML(prop.type))
        }
      }), _c('td', [_vm._v(_vm._s(prop.default))]), _c('td', {
        domProps: {
          "innerHTML": _vm._s(prop['zh-CN'] ? prop['zh-CN'].replace(/`(.*?)`/g, '<code>$1</code>') : '')
        }
      }), _c('td', [_vm._v(_vm._s(prop.version || '--'))])])
    }))])] : _vm._e(), (component.meta.events) ? [_c('h2', [_vm._v("事件")]), _c('table', [_vm._m(3, true), _c('tbody', _vm._l((component.meta.events), function(event, i) {
      return _c('tr', [_c('td', {
        staticClass: "prop-name"
      }, [_c('el-tooltip', {
        attrs: {
          "content": "点击复制",
          "placement": "left",
          "hide-after": 0,
          "open-delay": 50
        }
      }, [_c('span', {
        directives: [{
          name: "clipboard",
          rawName: "v-clipboard:copy",
          value: ('@' + i),
          expression: "'@' + i",
          arg: "copy"
        }, {
          name: "clipboard",
          rawName: "v-clipboard:success",
          value: (_vm.onCopy),
          expression: "onCopy",
          arg: "success"
        }]
      }, [_vm._v("@" + _vm._s(i))])])], 1), _c('td', {
        domProps: {
          "innerHTML": _vm._s(event.params ? event.params.replace(/`(.*?)`/g, '<code>$1</code>') : '--')
        }
      }), _c('td', {
        domProps: {
          "innerHTML": _vm._s(event['zh-CN'] ? event['zh-CN'].replace(/`(.*?)`/g, '<code>$1</code>') : '--')
        }
      }), _c('td', [_vm._v(_vm._s(event['version'] || '--'))])])
    }))])] : _vm._e(), (component.meta.slots) ? [_c('h2', [_vm._v("插槽")]), _c('table', [_vm._m(4, true), _c('tbody', _vm._l((component.meta.slots), function(slot, i) {
      return _c('tr', {
        class: {
          'slot-disabled': slot['status'] === 'deprecated'
        }
      }, [_c('td', {
        staticClass: "prop-name"
      }, [_c('el-tooltip', {
        attrs: {
          "content": "点击复制",
          "placement": "left",
          "hide-after": 0,
          "open-delay": 50
        }
      }, [_c('span', {
        directives: [{
          name: "clipboard",
          rawName: "v-clipboard:copy",
          value: (i),
          expression: "i",
          arg: "copy"
        }, {
          name: "clipboard",
          rawName: "v-clipboard:success",
          value: (_vm.onCopy),
          expression: "onCopy",
          arg: "success"
        }]
      }, [_vm._v(_vm._s(i === 'default' ? '默认插槽' : i))])])], 1), _c('td', {
        domProps: {
          "innerHTML": _vm._s(slot['zh-CN'] ? slot['zh-CN'].replace(/`(.*?)`/g, '<code>$1</code>') : '')
        }
      }), _c('td', [_vm._v(_vm._s(slot['version'] || '--'))])])
    }))])] : _vm._e(), (component.meta.methods) ? [_c('h2', [_vm._v("方法")]), _c('table', [_vm._m(5, true), _c('tbody', _vm._l((component.meta.methods), function(method, i) {
      return _c('tr', [_c('td', {
        staticClass: "prop-name"
      }, [_c('el-tooltip', {
        attrs: {
          "content": "点击复制",
          "placement": "left",
          "hide-after": 0,
          "open-delay": 50
        }
      }, [_c('span', {
        directives: [{
          name: "clipboard",
          rawName: "v-clipboard:copy",
          value: (i),
          expression: "i",
          arg: "copy"
        }, {
          name: "clipboard",
          rawName: "v-clipboard:success",
          value: (_vm.onCopy),
          expression: "onCopy",
          arg: "success"
        }]
      }, [_vm._v(_vm._s(i))])])], 1), _c('td', {
        domProps: {
          "innerHTML": _vm._s(method['params'] ? method['params'].replace(/`(.*?)`/g, '<code>$1</code>') : '')
        }
      }), _c('td', {
        domProps: {
          "innerHTML": _vm._s(method['zh-CN'] ? method['zh-CN'].replace(/`(.*?)`/g, '<code>$1</code>') : '')
        }
      }), _c('td', [_vm._v(_vm._s(method['version']))])])
    }))])] : _vm._e(), (component.meta.variables) ? [_c('a', {
      staticClass: "anchor",
      attrs: {
        "id": "variables"
      }
    }, [_vm._v("Variables")]), _c('br'), _c('h2', [_vm._v("样式变量")]), _c('table', [_vm._m(6, true), _c('tbody', _vm._l((component.meta.variables), function(variable, i) {
      return _c('tr', [_c('td', {
        staticClass: "prop-name"
      }, [_c('el-tooltip', {
        attrs: {
          "content": "点击复制",
          "placement": "left",
          "hide-after": 0,
          "open-delay": 50
        }
      }, [_c('span', {
        directives: [{
          name: "clipboard",
          rawName: "v-clipboard:copy",
          value: ('@' + variable.name),
          expression: "'@' + variable.name",
          arg: "copy"
        }, {
          name: "clipboard",
          rawName: "v-clipboard:success",
          value: (_vm.onCopy),
          expression: "onCopy",
          arg: "success"
        }]
      }, [_vm._v("@" + _vm._s(variable.name))])])], 1), _c('td', [(!_vm.$refs['propColor' + i] || (_vm.$refs['propColor' + i][0] && _vm.$refs['propColor' + i][0].style.backgroundColor)) ? _c('em', {
        ref: 'propColor' + i,
        refInFor: true,
        staticClass: "prop-color",
        style: ({
          backgroundColor: variable.value
        })
      }) : _vm._e(), _vm._v("\n                    " + _vm._s(variable.value) + "\n                  ")]), _c('td', [_vm._v(_vm._s(variable['desc']['zh-CN'] || '--'))]), _c('td', [_vm._v(_vm._s(variable.inherited_name))])])
    }))])] : _vm._e(), (component.meta.tips && component.meta.tips['zh-CN']) ? [_c('a', {
      staticClass: "anchor",
      attrs: {
        "id": "tips"
      }
    }, [_vm._v("重要提示及已知问题")]), _c('br'), _c('h2', [_vm._v("重要提示及已知问题")]), _c('div', [_c('ul', _vm._l((component.meta.tips['zh-CN']), function(tip) {
      return _c('li', [_c('el-tag', {
        staticClass: "component-tip-tag",
        attrs: {
          "size": "mini",
          "type": "success"
        }
      }, [_vm._v("Q")]), _c('span', {
        staticClass: "component-tip-question"
      }, [_vm._v(_vm._s(tip.q))]), _c('div', {
        staticClass: "tip-answer-box",
        domProps: {
          "innerHTML": _vm._s(tip.a)
        }
      })], 1)
    }))])] : _vm._e()], 2)]
  }), _c('br'), (_vm.issues.length) ? _c('div', [_c('a', {
    staticClass: "anchor",
    attrs: {
      "id": "Issues"
    }
  }, [_vm._v("Issues")]), _c('br'), _c('h2', [_vm._v("相关 issue")]), _c('ul', _vm._l((_vm.issues), function(issue) {
    return _c('li', [_c('a', {
      attrs: {
        "target": "_blank",
        "href": issue.html_url
      }
    }, [_vm._v("#" + _vm._s(issue.number) + " "), _c('span', {
      staticStyle: {
        "color": "#666"
      }
    }, [_vm._v(_vm._s(issue.title))])])])
  }))]) : _vm._e(), _c('br'), (_vm.gitMetas) ? _c('div', [_c('a', {
    staticClass: "anchor",
    attrs: {
      "id": "contributors"
    }
  }, [_vm._v("贡献者")]), _c('h2', [_vm._v("贡献者")]), _c('p', [_vm._v("该组件(包含文档)迭代次数 " + _vm._s(_vm.gitMetas.commitCount) + "，贡献人数 " + _vm._s(_vm.gitMetas.commitUniqueCount) + "\n        ")]), _vm._l((_vm.gitMetas.commitMembers), function(person) {
    return _c('a', {
      staticClass: "contributor-item",
      attrs: {
        "href": 'https://github.com/' + person.authorName,
        "target": "_blank",
        "title": 'contribute' + person.count
      }
    }, [_vm._v(_vm._s(person.authorName))])
  })], 2) : _vm._e(), _c('br'), (_vm.metas.changes) ? _c('div', [_c('a', {
    staticClass: "anchor",
    attrs: {
      "id": "changelog"
    }
  }, [_vm._v("Changelog")]), _c('br'), _c('h2', [_vm._v("发布日志")]), (_vm.metas.changes) ? _c('ul', [_vm._l((_vm.metas.changes), function(changelog, version) {
    return _vm._l((changelog['zh-CN']), function(log) {
      return _c('li', [_c('router-link', {
        staticClass: "changelog-version",
        attrs: {
          "to": '/zh-CN/changelog/' + version + '.html'
        }
      }, [_vm._v(_vm._s(version))]), _vm._v(" " + _vm._s(log) + "\n            ")], 1)
    })
  })], 2) : _vm._e()]) : _vm._e(), (_vm.metas.references) ? _c('h2', [_vm._v("参考资料")]) : _vm._e(), (_vm.metas.references) ? _c('ul', _vm._l((_vm.metas.references['zh-CN']), function(link) {
    return _c('li', [_c('a', {
      attrs: {
        "href": link.link,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(link.title))])])
  })) : _vm._e(), _c('el-dialog', {
    staticClass: "sourcec-code-dialog",
    attrs: {
      "top": "0",
      "width": "80%",
      "visible": _vm.sourceCodeDialogVisibility
    },
    on: {
      "update:visible": function($event) {
        _vm.sourceCodeDialogVisibility = $event
      }
    }
  }, [_c('div', {
    staticClass: "code-box",
    attrs: {
      "contenteditable": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.demoCode)
    }
  })])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("group")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("cell")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("title")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"title\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("value")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"value\"")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("cell")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("group")]), _vm._v(">")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tip"
  }, [_c('p', [_vm._v("Cell 组件只能在"), _c('code', [_vm._v("Group")]), _vm._v("中使用")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', [_vm._v("名字")]), _c('td', {
    staticStyle: {
      "width": "48px"
    }
  }, [_vm._v("类型")]), _c('td', [_vm._v("默认值")]), _c('td', [_vm._v("说明")]), _c('td', [_vm._v("版本要求")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', [_vm._v("名字")]), _c('td', [_vm._v("参数")]), _c('td', [_vm._v("说明")]), _c('td', [_vm._v("版本要求")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', [_vm._v("名字")]), _c('td', [_vm._v("说明")]), _c('td', [_vm._v("版本要求")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', [_vm._v("名字")]), _c('td', [_vm._v("参数")]), _c('td', [_vm._v("说明")]), _c('td', [_vm._v("版本要求")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', [_vm._v("名字")]), _c('td', [_vm._v("默认值")]), _c('td', [_vm._v("说明")]), _c('td', [_vm._v("继承自变量")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-bea84b60", module.exports)
  }
}

/***/ }),

/***/ 2492:
/***/ (function(module, exports) {

module.exports = {
	"commitCount": 1,
	"commitMembers": [
		{
			"count": 1,
			"authorName": "Bobjoy"
		}
	],
	"commitUniqueCount": 1
};

/***/ }),

/***/ 402:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1663)
}
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(1278),
  /* template */
  __webpack_require__(2433),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/runner/work/vux/vux/docs/zh-CN/components/cell.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] cell.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-bea84b60", Component.options)
  } else {
    hotAPI.reload("data-v-bea84b60", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// 77.a7346c21.js